export default __webpack_public_path__ + "static/IN-8015v6014_resTestBig-1cf0de05dd73a90d5a016d490340a6d7.webp";